<template>
  <div
    :am-mode="isActive ? 'edit' : 'show'"
    am-fields-array-item
    @click="editMode()"
    v-click-outside="showMode"
    ref="array"
    @keyup.esc="showMode"
    tabindex="1"
  >
    <div v-if="!isActive" am-show>{{ data.data.join(', ').toUpperCase() }}</div>
    <div
      v-else
      class="_display:flex _flex-direction:column"
      am-edit
      :style="isOpenTop ? 'bottom: -4px; top: auto;' : null"
    >
      <div
        v-for="(value, index) in data.data"
        :key="index"
        class="_display:inline-flex _align-items:center _width:100% _margin-bottom:1/4"
      >
        <i-input
          v-model="val[index]"
          @change="setChangedParts(index)"
        />
        <div class="_margin-left:1/4">
          <svg viewBox="0 0 24 24" am-icon="color" @click="delArray(index)">
            <use xlink:href="@/assets/icons.svg#minus"  x="0" y="0" width="24" height="24"></use>
          </svg>
        </div>
      </div>
      <svg am-icon viewBox="0 0 24 24" class="_margin-top:1/2" @click="addArray()">
        <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FieldsArrayItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isActive: false,
    isOpenTop: false
  }),
  computed: {
    val () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    setChangedParts (index) {
      if (this.val[index]) this.val[index] = this.val[index].toUpperCase()
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    },
    delArray (index) {
      this.val.splice(index, 1)
      this.setChangedParts()
    },
    addArray () {
      this.val.push('')
      this.setChangedParts()
    },
    editMode () {
      this.isActive = true
      this.$emit('editing', this.data.index)
      if (this.$refs.array.getBoundingClientRect().y / window.innerHeight * 100 > 50) {
        this.isOpenTop = true
      }
    },
    showMode () {
      this.isOpenTop = false
      this.isActive = false
    }
  }
}
</script>

<style lang="scss">
[am-fields-array-item] {
  [am-show] {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  [am-edit] {
    min-width: 10rem;
    .input-wrapper {
      width: 100%;
      input {
        text-transform: uppercase;
      }
    }
  }
}
</style>
